import { render, staticRenderFns } from "./correctionBox.vue?vue&type=template&id=042186f6&scoped=true&"
import script from "./correctionBox.vue?vue&type=script&lang=js&"
export * from "./correctionBox.vue?vue&type=script&lang=js&"
import style0 from "./correctionBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./correctionBox.vue?vue&type=style&index=1&id=042186f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042186f6",
  null
  
)

export default component.exports